// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import DataVaxiomRelationshipsList from './data'

export default function DataVaxiomRelationshipsListFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/DataVaxiomRelationshipsList">
      <DataVaxiomRelationshipsList {...props}>
        {children}
      </DataVaxiomRelationshipsList>
    </Flow>
  )
}
